import React from 'react'
import './Container.scss'

function Container({children}) {
  return (
    <div className='layout'>
        {children}
    </div>
  )
}

export default Container